import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles((theme) => {
  return {
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
  };
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultipleText(props) {
  const classes = useStyles();
  const [selectedData, setData] = React.useState([]);
  const [id, setIdValue] = React.useState('');

  const handleChange = () => {
    // setData(event.target.value);
  };

  const onChange = (event) => {
    setIdValue(event.target.value);
  };

  const addId = (e) => {
    e.preventDefault();
    if (id) {
      setData([...selectedData, id]);
      setIdValue('');
    }
  };

  const handleDelete = (item) => {
    setData(selectedData.filter((value) => { return item !== value; }));
  };

  React.useEffect(() => {
    if (props.selectedData) setData(props.selectedData);
  }, [props]);

  React.useEffect(() => {
    props.callBack(selectedData);
  });

  return (
    <>
      <InputLabel id="mutiple-chip-label">{props.name}</InputLabel>
      <Select
        labelId="mutiple-chip-label"
        id="mutiple-chip"
        multiple
        value={selectedData}
        onChange={handleChange}
        input={<Input id="select-multiple-chip" />}
        renderValue={(selected) => {
          return (
            <div className={classes.chips}>
              {selected.map((value, index) => {
                return (value ? (
                  <Chip
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    label={value}
                    className={classes.chip}
                  />
                ) : null);
              })}
            </div>
          );
        }}
        MenuProps={MenuProps}
      >
        <div>
          <TextField name="id" value={id} onChange={(e) => { onChange(e); }} />
          <Button color="primary" onClick={addId}>Add</Button>
        </div>
        {selectedData.map((item, index) => {
          return (
            <Chip
              // eslint-disable-next-line react/no-array-index-key
              key={`${item}_${index}`}
              label={item}
              value={item}
              className={classes.chip}
              onDelete={() => { return handleDelete(item); }}
            />
          );
        })}
      </Select>
    </>
  );
}
